/**
*	Custom Functions
*/

jQuery(document).ready(function($) {

    // Top pull-down navigation bar location/product selection.
	var $location = $('select.location');
	var $product = $('select.product');
	var $defaultProduct = $product.html();

	$location.change(function() {
	    if( $(this).val() == '' ){
	    	$product.empty().append($defaultProduct);
	    	// $('#location-submit').addClass('button-three').removeClass('button-one');
	    }else{
	    	// $('#location-submit').removeClass('button-three').addClass('button-one');
		    $product.empty().append(function() {
		        var output = '';
		        $.each(selectValues[$location.val()], function(key, value) {
		            output += '<option value="'+value+'">' + key + '</option>';
		        });
		        return output;
		    });
	    }
	});

	$('#location-submit').on('click',function(event) {
		event.preventDefault();
		if( $product.val() != '' ) {
			window.open($product.val(), '_blank');
		}
	});

	$('.slider').slick({
		autoplay: true,
		autoplaySpeed: 5500,
  		dots: true,
		adaptiveHeight: true,
		pauseOnHover: true,
		pauseOnFocus: true
	});

	// Height of footer bar in px
	footerHeight = 350;
	c = 0;
	getDocH = getDocHeight();

	// $(window).scroll(function() {
	//
	// 	if ( $('.main-menu').length ) {
	//
	// 		// If user resizes the window or just get the starting size
	// 		$(window).resize(function() {
	// 			browserHeight = $(window).height();
	// 		});
	// 		browserHeight = $(window).height();
	//
	// 		if($(window).scrollTop() + $(window).height() > getDocH - footerHeight) {
	//
	// 			// Offset menu height
	// 			if (c == 0) {
	// 				var scrollTop = $(window).scrollTop(),
	// 				elementOffset = $('.main-menu').offset().top,
	// 				distance      = (elementOffset - scrollTop - footerHeight);
	// 				c = 1;
	// 			}
	//
	// 			$('.main-menu').css({
	// 				'position':'static',
	// 				'padding-top':scrollTop + 65
	// 			});
	//
	// 		} else {
	//
	// 			$('.main-menu').css({
	// 				'position':'fixed',
	// 				'padding':'65px 20px'
	// 			});
	// 			c = 0;
	// 		}
	// 	}
	// });
});

// Multibrowser document height, http://james.padolsey.com/javascript/get-document-height-cross-browser/
function getDocHeight() {
    var D = document;
    return Math.max(
        D.body.scrollHeight, D.documentElement.scrollHeight,
        D.body.offsetHeight, D.documentElement.offsetHeight,
        D.body.clientHeight, D.documentElement.clientHeight
    );
}
